import CommonSubtitle from "@/components/common/CommonSubtitle";
import Image, { StaticImageData } from "next/image";

export type ToolGridAreaType = {
  text: string;
  subtext?: string;
  subtext1?: string;
  subtext2?: string;
  stepsData?: string[];
  image: StaticImageData;
};

const ToolGridArea = ({
  gridAreaInfo,
}: {
  gridAreaInfo: ToolGridAreaType[];
}) => {
  return (
    <div className="mb-6 flex flex-col gap-10 sm:mb-8 md:mb-10 md:gap-28 lg:mb-12 xl:gap-32">
      {gridAreaInfo.map((item, index) => (
        <div
          className={`flex flex-col gap-6 xlg:gap-8 xl:gap-10 ${index % 2 === 0 ? "lg:flex-row-reverse" : "lg:flex-row"
            } `}
          key={index}
        >
          <div className="flex w-full items-center justify-center md:-mt-8">
            <div className="flex flex-col gap-4 xl:gap-6">
              <div className="flex flex-col gap-2 xl:gap-4">
                <h3 className="text-[20px] font-medium leading-6 text-[#202020] lg:text-[22px]">
                  {item.text}
                </h3>
                {item.subtext ? (
                  <CommonSubtitle
                  >
                    {item.subtext}
                  </CommonSubtitle>
                ) : (
                  <div>
                    <p className="text-[14px] font-normal text-[#202020] xl:text-[16px]">
                      {item.subtext1}
                    </p>
                    <ul className="list-disc p-6 pl-10 text-[#9B9B9B]">
                      {item.stepsData?.map((step) => (
                        <li key={step}>
                          <p className="text-[14px] font-normal text-[#202020] xl:text-[16px]">
                            {step}
                          </p>
                        </li>
                      ))}
                    </ul>
                    <p className="text-[14px] font-normal text-[#202020] xl:text-[16px]">
                      {item.subtext2}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="relative h-fit w-full overflow-hidden xl:max-h-[542px]">
            <Image src={item.image} alt={`${item.text} - Kroolo tool feature`} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToolGridArea;
